/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-08 15:15:28
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-08-06 19:50:36
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Modal/index.tsx
 */
import React, { useEffect, useState } from 'react';

import { Button, Modal, Select } from '@/src/components/Antd';
import {
  EnumActionType,
  LinkModuleType,
  EnumLinkType,
} from '@/src/types/common/linkType';
import { get } from 'lodash';
import LinkModule from '../index';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';
import { useSalesChannelModeWithSister } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { SalesChannelModeWithSister } from '@/src/types/common/SalesChannel';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

type Props = {
  visible: boolean;
  autofillNoneType?: boolean;
  onCancel: () => void;
  linkTypeFilter?: Array<string>;
  scopeVariables: any;
  value: LinkValue;
  onChange: (value: LinkValue) => void;
  selectedLinkType?: Array<any>;
  fetchProps?: { [propsName: string]: any };
  excludeLinkType?: Array<string>;
  cannotAddToCart?: boolean;
  salesChannelSelectProps?: any;
};

type LinkValue = {
  label: string;
  uuid: string;
  linkType: LinkModuleType | EnumLinkType;
  action: string;
  salesChannelUuid?: string;
  draggableId?: string;
  linkImage?: any;
  item?: any;
};

function LinkModuleModal({
  visible,
  onCancel,
  linkTypeFilter,
  scopeVariables,
  autofillNoneType = true,
  value,
  onChange,
  selectedLinkType,
  fetchProps,
  excludeLinkType,
  cannotAddToCart,
  salesChannelSelectProps,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scMode = useSalesChannelModeWithSister();

  const [v, setV] = useState(value);

  useEffect(() => {
    setV(value);
  }, [value]);

  const handleSubmit = () => {
    const action = get(v, 'action');
    const linkType = get(v, 'linkType');
    const result = autofillNoneType
      ? v.linkType
        ? v
        : generateNoneLinkData()
      : v;
    if (linkType === LinkModuleType.Product) {
      if (action) {
        onChange(result);
        onCancel();
      }
    } else {
      onChange(result);
      onCancel();
    }
  };

  const handleChangeAction = (value: string) => {
    setV((v) => ({ ...v, action: value }));
  };

  return (
    <Modal
      width={600}
      title={getI18n('general.linkModule.Modal.link')}
      visible={visible}
      onCancel={onCancel}>
      <div className={styles.container}>
        <div className={styles.item}>
          <LinkModule
            header={
              <div className={styles.label}>
                {getI18n('general.linkModule.Modal.link')}
              </div>
            }
            linkTypeFilter={linkTypeFilter}
            scopeVariables={scopeVariables}
            value={v}
            onChange={(v: any) => {
              setV(v);
            }}
            selectedLinkType={selectedLinkType}
            fetchProps={fetchProps}
            excludeLinkType={excludeLinkType}
            salesChannelSelectProps={salesChannelSelectProps}
          />
        </div>
        {v.linkType === 'Product' && (
          <div className={styles.item}>
            <div className={styles.label}>
              {getI18n('general.linkModule.Modal.action')}
            </div>
            <Select
              size={'large'}
              value={v.action}
              error={!v.action}
              placeholder={getI18n(
                'general.linkModule.Modal.action_placeholder',
              )}
              onChange={handleChangeAction}
              options={
                scMode === SalesChannelModeWithSister.E_Only
                  ? [
                      {
                        value: EnumActionType.ProductDetail,
                        label: getI18n(
                          'general.linkModule.Modal.action_detail',
                        ),
                      },
                      ...(cannotAddToCart
                        ? []
                        : [
                            {
                              value: EnumActionType.Cart,
                              label: getI18n(
                                'general.linkModule.Modal.add_shoppingcart',
                              ),
                            },
                          ]),
                    ]
                  : [
                      {
                        value: EnumActionType.ProductDetail,
                        label: getI18n(
                          'general.linkModule.Modal.action_detail',
                        ),
                      },
                    ]
              }
            />
          </div>
        )}
        <div className={styles.footer}>
          <Button className={styles.button} onClick={onCancel}>
            {getI18n('general.commonHeader.discard_text')}
          </Button>
          <Button
            className={styles.button}
            type='primary'
            onClick={handleSubmit}>
            {getI18n('general.linkModule.Modal.add')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default LinkModuleModal;
